import {
	WrapperWorkflowReadOnlyFieldDtoGroup,
	WrapperWorkflowStatusDto,
} from './../../workflow-utils';
import {
	Component,
	Input,
	OnInit,
	TemplateRef,
	ViewChild,
} from '@angular/core';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { NzModalService } from 'ng-zorro-antd/modal';
import { FormBuilder, Validators } from '@angular/forms';
import { WorkflowFormButtonComponent } from '../workflow-form-button/workflow-form-button.component';
import {
	doGetInvalidControlsList,
	doTouchAllFields,
	WrapperWorkflowButtonDto,
	WrapperWorkflowSectionDto,
	WrapperWorkflowStepDto,
} from '../../workflow-utils';
import { WorkflowStepSectionDto } from '../../../../../service/dto';

@Component({
	selector: 'app-workflow-form-step',
	standalone: false,
	templateUrl: './workflow-form-step.component.html',
	styleUrl: './workflow-form-step.component.scss',
})
export class WorkflowFormStepComponent implements OnInit {
	@Input() input!: WrapperWorkflowStepDto;
	@Input() mode!: 'Workflow' | 'ProductWorkflow';
	@ViewChild('editPopup', { static: true }) editPopup!: TemplateRef<any>;
	selectedTabIndex = 0;
	faTrash = faTrashAlt;

	constructor(
		private fb: FormBuilder,
		private modalService: NzModalService,
	) {}
	ngOnInit(): void {}

	doEdit() {
		const modal = this.modalService.create({
			nzTitle: 'Step Editor',
			nzContent: this.editPopup,
			nzFooter: null,
		});
	}
	doRemove() {
		if (this.input.payload.questionnaire) {
			WrapperWorkflowStepDto.removeQuestionnaire(this.input.parent!);
		} else {
			const index = this.input.parent.steps.indexOf(this.input);
			WrapperWorkflowStepDto.remove(this.input.parent!, index);
		}
	}

	addSection() {
		WrapperWorkflowSectionDto.add(this.fb, this.input!);
	}
	private forceButtonStatus(
		button: WrapperWorkflowButtonDto,
		status: WrapperWorkflowStatusDto,
	): void {
		const statusId = status.payload.id;

		// KEEP PAYLOAD AND FORM VALUE IN SYNC
		button.payload.statusId = statusId;
		button.formGroup.get('statusId')?.setValue(statusId);
		button.formGroup.get('statusId')?.markAsDirty();
		button.formGroup.get('statusId')?.updateValueAndValidity();
	}

	private sortButtons(): void {
		this.input.buttons = this.input.buttons.sort(
			(i1, i2) =>
				(i1.formGroup.get('orderIndex')?.value ?? 0) -
				(i2.formGroup.get('orderIndex')?.value ?? 0),
		);
	}

	addButton(status: WrapperWorkflowStatusDto) {
		const button = WrapperWorkflowButtonDto.add(
			this.fb,
			this.input!,
			status,
		);

		this.forceButtonStatus(button, status);

		const modal = this.modalService.create({
			nzTitle: 'Add Button',
			nzContent: WorkflowFormButtonComponent,
			nzFooter: null,
		});

		modal.componentInstance!.input = button;
		modal.componentInstance!.mode = this.mode;

		modal.afterClose.subscribe(() => {
			this.forceButtonStatus(button, status);
			this.sortButtons();
		});
	}

	viewButton(
		input: WrapperWorkflowButtonDto,
		status: WrapperWorkflowStatusDto,
	) {
		this.forceButtonStatus(input, status);

		const modal = this.modalService.create({
			nzTitle: 'Edit Button',
			nzContent: WorkflowFormButtonComponent,
			nzFooter: null,
		});

		modal.componentInstance!.input = input;
		modal.componentInstance!.mode = this.mode;

		modal.afterClose.subscribe((result) => {
			if (result?.action == 'delete') {
				WrapperWorkflowButtonDto.remove(
					input.parent,
					input.parent.buttons.indexOf(input),
				);
				return;
			}

			this.forceButtonStatus(input, status);
			this.sortButtons();
		});
	}
	removeSection(item: WrapperWorkflowSectionDto) {
		const index = this.input.sections.indexOf(item);
		WrapperWorkflowSectionDto.remove(this.input!, index);
	}

	removeButton(item: WrapperWorkflowButtonDto) {
		const index = this.input.buttons.indexOf(item);
		WrapperWorkflowButtonDto.remove(this.input!, index);
	}
	selectAll(input: WrapperWorkflowReadOnlyFieldDtoGroup) {
		input.fields.forEach((item) => item.formControl.setValue(true));
	}
	selectNone(input: WrapperWorkflowReadOnlyFieldDtoGroup) {
		input.fields.forEach((item) => item.formControl.setValue(false));
	}

	touchAllFields() {
		doTouchAllFields(this.input.formGroup);
	}
	getInvalidControlsList() {
		return doGetInvalidControlsList(this.input.formGroup);
	}

	addStatus(): void {
		const option = this.fb.group({
			value: ['', Validators.required],
			label: ['', Validators.required],
		});
		WrapperWorkflowStatusDto.add(this.fb, this.input!);
	}
	removeStatus(index: number): void {
		WrapperWorkflowStatusDto.remove(this.input, index);
	}
	get isProductWorkflow(): boolean {
		return this.mode == 'ProductWorkflow';
	}
}
